var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$root.loading
        ? _c("Skeleton", { attrs: { cols: _vm.listView ? 12 : 6, length: 6 } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.$root.loading
        ? _c(
            "v-row",
            {
              directives: [{ name: "masonry", rawName: "v-masonry" }],
              staticClass: "z-0",
            },
            _vm._l(_vm.products, function (product, idx) {
              return _c(
                "v-col",
                {
                  key: product.id,
                  staticClass: "soli-round",
                  attrs: { cols: _vm.listView ? "12" : "6" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-round",
                      attrs: {
                        ripple: false,
                        flat: "",
                        outlined: !_vm.listView,
                      },
                    },
                    [
                      _vm.can("Manage inventory")
                        ? _c(
                            "v-menu",
                            {
                              attrs: { left: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "mt-4 right-3",
                                                staticStyle: {
                                                  "z-index": "100",
                                                  background: "white",
                                                },
                                                attrs: {
                                                  absolute: "",
                                                  icon: "",
                                                  small: "",
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("more_vert")])],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "v-list",
                                [
                                  _vm.is("Admin")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            href: `/admin/product/${product.id}/edit`,
                                          },
                                        },
                                        [_vm._v("Admin Edit")]
                                      )
                                    : _vm._e(),
                                  _vm.can("Manage products")
                                    ? _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            disabled:
                                              product.category == "gifts",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "manageProduct",
                                                product
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Edit Product")]
                                      )
                                    : _vm._e(),
                                  product.physical
                                    ? _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              _vm.showInventory = product
                                            },
                                          },
                                        },
                                        [_vm._v("Manage Inventory")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "align-center" },
                        [
                          product.photo
                            ? _c(
                                "v-avatar",
                                { attrs: { size: "128", tile: "" } },
                                [
                                  _c("v-img", {
                                    staticClass: "soli-round",
                                    attrs: {
                                      position: "top center",
                                      src: product.imagePath
                                        ? `/api/image-service/128x128/${encodeURIComponent(
                                            product.imagePath
                                          )}`
                                        : product.photo,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            {
                              staticClass: "flex align-center",
                              staticStyle: {
                                overflow: "hidden",
                                "min-height": "128px",
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                { staticClass: "pb-0" },
                                [
                                  !product.photo
                                    ? _c(
                                        "v-list-item-title",
                                        {
                                          staticStyle: {
                                            "white-space": "normal",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(product.name) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _c("small", { staticClass: "pr-3" }, [
                                        _vm._v(_vm._s(product.name)),
                                      ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass: "caption",
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(product.description) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col" },
                                    [
                                      product.prices.length > 1 &&
                                      !product.multiple_prices &&
                                      product.prices.some((e) => e.package_name)
                                        ? _c(
                                            "v-chip-group",
                                            {
                                              attrs: {
                                                mandatory: "",
                                                "active-class": "primary--text",
                                              },
                                              model: {
                                                value: product.price,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    product,
                                                    "price",
                                                    $$v
                                                  )
                                                },
                                                expression: "product.price",
                                              },
                                            },
                                            _vm._l(
                                              product.prices
                                                .filter(
                                                  (e) =>
                                                    e.duration ==
                                                    product.price.duration
                                                )
                                                .sort(
                                                  (a, b) => a.passes - b.passes
                                                ),
                                              function (price, idx) {
                                                return _c(
                                                  "div",
                                                  { key: idx },
                                                  [
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          outlined: "",
                                                          value: price,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.$log(
                                                              price.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            price.package_name ??
                                                              "Full Price"
                                                          ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      product.prices.length > 1 &&
                                      !product.multiple_prices &&
                                      product.selectable_duration &&
                                      product.prices.some((e) => e.duration)
                                        ? _c(
                                            "v-chip-group",
                                            {
                                              attrs: {
                                                mandatory: "",
                                                "active-class": "primary--text",
                                              },
                                              model: {
                                                value: product.price,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    product,
                                                    "price",
                                                    $$v
                                                  )
                                                },
                                                expression: "product.price",
                                              },
                                            },
                                            _vm._l(
                                              product.prices
                                                .filter(
                                                  (e) =>
                                                    e.package_name ==
                                                    product.price.package_name
                                                )
                                                .sort(
                                                  (a, b) =>
                                                    a.duration - b.duration
                                                ),
                                              function (price, idx) {
                                                return _c(
                                                  "div",
                                                  { key: idx },
                                                  [
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          outlined: "",
                                                          value: price,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.$log(
                                                              price.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              price.duration +
                                                                " min"
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "font-bold py-1" },
                                    [
                                      product.prices.length > 1 &&
                                      product.multiple_prices
                                        ? _c(
                                            "v-menu",
                                            {
                                              attrs: { right: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "px-2 mr-1",
                                                                staticStyle: {
                                                                  "text-transform":
                                                                    "none",
                                                                },
                                                                attrs: {
                                                                  outlined: "",
                                                                  small: "",
                                                                  text: "",
                                                                  rounded: "",
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  product.price
                                                                    .formatAmount
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "secondary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "arrow_drop_down"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                _vm._l(
                                                  product.prices,
                                                  function (price) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: price.id,
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            product.price =
                                                              price
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            price.formatAmount
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  product.price.formatAmount
                                                ) +
                                                "\n                                "
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      product.physical
                                        ? _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                product.price.inventory
                                                  ?.current_stock > 0
                                                  ? "In-stock"
                                                  : "Out-of-stock"
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item",
                                    {
                                      staticClass: "px-0",
                                      class: {
                                        "flex justify-end": !product.photo,
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "soli-round",
                                          attrs: { small: "", color: "accent" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "addProductToCart",
                                                product
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Add to Cart")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.listView && idx < _vm.products.length - 1 && _vm.divider
                    ? _c("v-divider", { staticClass: "mt-5" })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showInventory
        ? _c("ManageInventory", {
            attrs: { product: _vm.showInventory },
            on: {
              reset: function ($event) {
                _vm.showInventory = false
              },
              success: function ($event) {
                return _vm.$emit("success")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }